/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React from 'react';

const ScormFile = ({
  match: {
    params: { id },
  },
}) => (
  <div>
    <Typography variant="h5">Visor de Scorms</Typography>
    <iframe
      style={{
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
      }}
      frameBorder={0}
      title="Visor scorm"
      // src='http://google.es'
      src={`${process.env.REACT_APP_API}/upload/${id}/content`}
    />
  </div>
);

export default ScormFile;
